import React, { ReactElement, useRef } from 'react';
import { Text, VStack } from '@chakra-ui/react';
import { BlockInput } from 'components/worksheet/common/BlockInput';
import { TextQuestionOrientationAnswer } from '../TextQuestionOrientationAnswer';
import { TQBlockProps } from '../TextQuestionBlock';

type Props = TQBlockProps;

export const ReviewTQBlock = ({ block }: Props): ReactElement => {
  const answerRef = useRef<HTMLTextAreaElement>(null);

  return (
    <VStack
      border="default"
      borderColor="border.accent"
      borderRadius="l"
      p="l"
      gap="l"
      width="100%"
      alignItems="flex-start"
      contentEditable={false}
      bg="grey.white"
    >
      <Text textStyle="h4.medium" color="text.primary" whiteSpace="pre-line">
        {block.props.question}
      </Text>

      <VStack gap="15px" width="100%" alignItems="flex-start">
        <BlockInput
          name="answer"
          value={block.props.answer}
          initialRows={3}
          placeholder="Gib deine Antwort hier ein..."
          disabled
          ref={answerRef}
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          onChange={() => {}}
        />

        <TextQuestionOrientationAnswer correctAnswer={block.props.correctAnswer} />
      </VStack>
    </VStack>
  );
};
